enum SsoDialogType {
    None,
    OmexConsent,
    MFASignIn,
}

export default SsoDialogType;
